import React from "react";

const CategoryItem = function (props) {
    const {category, isCategoryActive, viewSize} = props;
    return <span key={category.id} className={'category-item'} style={props.categoryStyle}
            onClick={() => props.onClick(category)}
            onMouseEnter={() => props.onMouseEnter(category)}
            onMouseLeave={() => props.onMouseLeave()}>
        <span className={'icon-item'} style={props.iconStyle}>
            <img src={category.icon} alt={category.icon} style={{width: '100%', height: '100%'}}/>
        </span>
        {(isCategoryActive && !['xsmall', 'small'].includes(viewSize)) &&
                <span className={'category-description'} style={{ color: props.textColor || category.color}}>
                    {category.description}
                </span>
        }
    </span>
};

CategoryItem.defaultProps = {
    onClick: ()=>{},
    onMouseLeave: ()=>{},
    onMouseEnter: ()=>{},
}

export {CategoryItem}